import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { INews_Item } from '@shared/constants/models.const';
import { NgClass } from '@angular/common';
import { TagSectionComponent } from '@shared/components/tag-section/tag-section.component';
import { HelperService } from '../../../../services/helper.service';

@Component({
  selector: 'app-news-section',
  imports: [
    RemoveHtmlPipe,
    NgClass,
    TagSectionComponent,
  ],
  templateUrl: './news-section.component.html',
  styleUrl: './news-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsSectionComponent {

  newTabLink = input(false);

  noLeftMargin = input(false);
  showShortTitle = input<boolean>(false);
  news = input.required<INews_Item | any>();
  isLastNews = input<boolean>(false);
  customDateField = input<string>('');
  readonly HELPER = inject(HelperService);

}
